import * as React from 'react';
import {useEffect} from 'react';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function BasicRating({showResults}) {
  const [value, setValue] = React.useState(null);
  const RESULT = 4.4
  // const RESULT = faker.number.float({
  //     max: 5,
  //     min: 2,
  //     precision: 0.1
  // })
  useEffect(() => {
    if (showResults === true) {
      setValue(RESULT)
    }

  }, [showResults])

  return (
    <Box
      id={'rating-question'}
      sx={{
        width: '100%'
      }}
    >

      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >

        <Rating
          name="simple-controlled"
          value={value}
          precision={showResults ? 0.1 : 1}
          readOnly={showResults}
          size={'large'}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        />
        {showResults ? <Typography variant={'h6'}>{RESULT}</Typography> : null}
      </Stack>
    </Box>
  );
}
